import { FC, forwardRef, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { FAIcon, IconStyle } from '../Icons';
import { CustomArrowProps, CustomIndicatorProps, ImageSliderPropTypes, Slide } from './types/propTypes';

import "react-responsive-carousel/lib/styles/carousel.min.css";
import styles from "./ImageSlider.module.scss";

const ImageSlider: FC<ImageSliderPropTypes> = forwardRef<HTMLDivElement | undefined, ImageSliderPropTypes>(
  (
    {
      slides = [],
      onClick
    },
  ) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(0);
    const hasPrev = selectedIndex > 0;
    const hasNext = selectedIndex < slides.length - 1;

    const handleIndexChange = (index: number) => {
      setSelectedIndex(index);
    };

    const CustomPrevButton: React.FC<CustomArrowProps> = ({ icon, iconStyle, onClick }: CustomArrowProps) => (
      <button className={`${styles['custom-arrow']} ${styles['custom-prev']}`} onClick={onClick}>
        <FAIcon iconName={icon} iconStyle={iconStyle} className={`${styles['custom-arrow-icon']}`} />
      </button>
    );

    const CustomNextButton: React.FC<CustomArrowProps> = ({ icon, iconStyle, onClick }: CustomArrowProps) => (
      <button className={`${styles['custom-arrow']} ${styles['custom-next']}`} onClick={onClick}>
        <FAIcon iconName={icon} iconStyle={iconStyle} className={`${styles['custom-arrow-icon']}`} />
      </button>
    );

    const CustomIndicator: React.FC<CustomIndicatorProps> = ({ isSelected, index, onClick }: CustomIndicatorProps) => (
      <li
        className={`${styles['custom-indicator']}`}
        style={{
          backgroundColor: isSelected ? '#38539a' : '#e4e4e4'
        }}
        onClick={onClick}
        role="button"
        key={index}
        tabIndex={0}
      />
    );

    return (
      <div>
        <Carousel
          renderArrowPrev={(onClickHandler, _, label) =>
            hasPrev && <CustomPrevButton icon={'chevron-left'} iconStyle={IconStyle.SOLID} onClick={onClickHandler} />
          }
          renderArrowNext={(onClickHandler, _, label) =>
            hasNext && <CustomNextButton icon={'chevron-right'} iconStyle={IconStyle.SOLID} onClick={onClickHandler} />
          }
          // renderIndicator={(onClickHandler, isSelected, index, label) => 
          //   <CustomIndicator isSelected={isSelected} onClick={onClickHandler} index={index} />
          // }
          infiniteLoop
          swipeable
          showStatus={false}
          showThumbs={false}
          showIndicators={false}
          selectedItem={selectedIndex}
          showArrows={selectedIndex < slides.length - 1} // Show arrow only when there is a next image
          onChange={handleIndexChange}
          className={styles['custom-carousel']}
          onClickItem={onClick}
        >
          {slides.map((slide: Slide, index: number) => (
            <div key={index}>
              <img src={slide.src} alt={slide.alt} className={styles['carousel-image']} />
            </div>
          ))}
        </Carousel>
        <div className={`${styles['custom-indicators']}`}>
          {slides.map((_, index) => (
            <CustomIndicator
              key={index}
              isSelected={index === selectedIndex}
              onClick={() => handleIndexChange(index)}
            />
          ))}
        </div>
      </div>
    );
  }
)

ImageSlider.displayName = 'ImageSlider';
export default ImageSlider;